document.addEventListener(
  "DOMContentLoaded",
  () => {

    const sliders =
      document.querySelectorAll(
        ".featured-products-slider"
      );

    sliders.forEach((slider) => {

      const track =
        slider.querySelector(
          "[data-slider]"
        );

      const prev =
        slider.querySelector(
          ".featured-products-slider__arrow--prev"
        );

      const next =
        slider.querySelector(
          ".featured-products-slider__arrow--next"
        );

      if (!track) return;

      const scrollAmount = 320;

      next?.addEventListener(
        "click",
        () => {

          track.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
          });

        }
      );

      prev?.addEventListener(
        "click",
        () => {

          track.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
          });

        }
      );

    });

  }
);